import TicketParam from './TicketParam'

export default TicketParam
